import { z } from "zod";

const YOUTUBE_VIDEO_ID_PATTERN = /^[a-zA-Z0-9_-]{11}$/;
const YOUTUBE_HOSTS = new Set([
	"youtube.com",
	"m.youtube.com",
	"youtube-nocookie.com",
	"youtu.be",
]);

export function getYoutubeVideoId(value?: string | null) {
	const trimmedValue = value?.trim();

	if (!trimmedValue) {
		return null;
	}

	if (YOUTUBE_VIDEO_ID_PATTERN.test(trimmedValue)) {
		return trimmedValue;
	}

	try {
		const url = new URL(
			trimmedValue.includes("://") ? trimmedValue : `https://${trimmedValue}`,
		);
		const hostname = url.hostname.replace(/^www\./, "");

		if (!YOUTUBE_HOSTS.has(hostname)) {
			return null;
		}

		if (hostname === "youtu.be") {
			const videoId = url.pathname.split("/").filter(Boolean).at(0);
			return videoId && YOUTUBE_VIDEO_ID_PATTERN.test(videoId) ? videoId : null;
		}

		const videoIdFromParam = url.searchParams.get("v");
		if (videoIdFromParam && YOUTUBE_VIDEO_ID_PATTERN.test(videoIdFromParam)) {
			return videoIdFromParam;
		}

		const [, pathType, videoIdFromPath] = url.pathname.split("/");
		const supportedPathTypes = ["embed", "shorts", "live"];

		if (
			supportedPathTypes.includes(pathType) &&
			YOUTUBE_VIDEO_ID_PATTERN.test(videoIdFromPath)
		) {
			return videoIdFromPath;
		}
	} catch {
		return null;
	}

	return null;
}

export const youtubeLinkField = z
	.string()
	.trim()
	.optional()
	.refine((value) => !value || getYoutubeVideoId(value) !== null, {
		message: "val.youtubeLink",
	});
